import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import Arrow from "@Resources/images/iconsets/arrow.svg?react";
import classNames from "classnames";
import { useState } from "react";

type DropdownProps = {
  icon?: React.ReactNode;
  title: string;
  children: React.ReactNode;
  offscreenTitle?: string;
};

const Dropdown = ({ icon, title, children, offscreenTitle }: DropdownProps) => {
  const { t } = useTranslations();
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      <button
        data-testid="weather-warning-dropdown"
        onClick={() => setExpanded(!expanded)}
        className={classNames(
          "m:w-full m:clickable-primary m:p-4 m:text-center",
          {
            "m:hover:bg-blue-750 m:focus:bg-blue-750 m:dark:hover:bg-blue-850 m:dark:focus:bg-blue-850":
              expanded,
          },
        )}
        aria-live="polite"
        aria-expanded={expanded}>
        <div className="m:flex m:items-center m:justify-between">
          <div className="m:flex m:gap-2">
            {icon}
            <span className="m:my-auto m:items-center m:font-sans m:text-xl m:leading-normal m:font-medium m:tracking-0.2">
              {title}
              {offscreenTitle && (
                <span className="m:sr-only">{offscreenTitle}</span>
              )}
              <span className="m:sr-only">
                {t(expanded ? "forecast.a11yCollapse" : "forecast.a11yExtend")}
              </span>
            </span>
          </div>
          <Arrow
            className={classNames("m:transition-transform m:duration-300", {
              "m:rotate-90": !expanded,
              "m:rotate-[270deg]": expanded,
            })}
          />
        </div>
      </button>
      <div
        aria-hidden={!expanded}
        className={classNames(
          "m:grid m:w-full m:bg-blue-750 m:px-4 m:pt-0 m:transition-grid-row m:duration-300 m:ease-in-out m:dark:bg-blue-850",
          {
            "m:grid-rows-[0fr]": !expanded,
            "m:grid-rows-[1fr] m:pb-4": expanded,
          },
        )}>
        <div className="m:overflow-hidden m:text-warmgrey-25">{children}</div>
      </div>
    </>
  );
};

export default Dropdown;
